module.exports = __webpack_public_path__ + "static/media/heart_icon0de482810bf5e22501adb9bea1657ec9.webp";